<template>
  <div class="card">
    <div class="card-header content-detail-header">
      <div class="d-flex align-items-center">
        <app-title-text2 class="mr-auto" text="診察メモ"></app-title-text2>
        <app-link
          class="mr-2 m_edit-examination_memo"
          text="編集"
          @click.native="toggleEditing()"
        ></app-link>
      </div>
    </div>
    <div class="card-body content-detail-body">
      <div class="content-form-row">
        <div class="tab-content mb-3">
          <div
            v-if="!isEditing"
            id="pills-content1"
            class="m_clinic_questionnaires"
            style="white-space: pre-wrap"
          >
            <!---->{{ oldValue }}
          </div>
          <div v-else id="pills-content2">
            <textarea
              id="question_memo"
              v-model="value"
              name="questionnaire[memo]"
              rows="3"
              class="form-control content-textarea"
              placeholder="本文を入力"
            ></textarea>
          </div>
        </div>
        <ul v-if="isEditing" class="nav nav-pills content-detail-nav">
          <li class="nav-item content-detail-nav-item">
            <app-normal-button
              class="active"
              title="キャンセル"
              @click.native="finishEditing()"
            ></app-normal-button>
          </li>
          <li class="nav-item content-detail-nav-item-save">
            <app-primary-button class="active" title="保存" @click.native="save()"></app-primary-button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import TitleText2 from '../common/text/title-text2.vue';

export default {
  components: {
    appTitleText2: TitleText2,
  },
  props: {
    text: {
      type: String,
      default: '',
    },
    action: {
      type: String,
      default: '',
    },
    token: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isEditing: false,
      oldValue: this.text,
      value: this.text,
    };
  },
  methods: {
    toggleEditing() {
      this.isEditing = !this.isEditing;
    },
    finishEditing() {
      this.isEditing = false;
      this.value = this.oldValue;
    },
    save() {
      let memo = this.value;

      $.ajax({
        url: this.action,
        type: 'POST',
        data: {
          utf8: '✓',
          _method: 'patch',
          authenticity_token: this.token,
          questionnaire: {
            memo: memo,
          },
        },
      })
        .then(() => {
          this.oldValue = memo;
          this.isEditing = false;
        })
        .catch(() => {
          this.$swal('登録に失敗しました。');
        });
    },
  },
};
</script>

<style lang="sass" scoped>
.m_edit-examination_memo
  color: #28c3cd!important
  cursor: pointer
  font-size: 18px
.content-detail-nav
    position: relative
    height: 38px
    .content-detail-nav-item
        position: absolute
        width: 0
        top: 0
        left: 0
        z-index: 2
    .content-detail-nav-item-save
        position: absolute
        width: 0
        top: 0
        right: 56px
.content-textarea
    border: solid 2px #8ce1e6

#pills-content1.m_clinic_questionnaires
  max-height: 300px
  overflow-y: scroll

#question_memo
  min-height: 300px
  resize: vertical
</style>
